<template>
    <li class="recommend-card" @click="eventTrack('CLICK_INDEX_RECOMMEND')">
        <a href="javascript:;" @click="goProductUrl(form)">
            <div class="img-ctn" v-lazy:background-image="form.imgUrl">
                <span class="info">
                    <span class="category">{{form.categoryName}}</span>
                    <span class="satisfaction">{{form.satisfaction || 100}}%满意度</span>
                </span>
            </div>
            <h3 class="name">{{form.productName}}</h3>
            <div class="price-ctn">
                <span class="price"><i>￥</i><em>{{form.startPrice}}</em>起</span>
                <span class="count" v-if="form.travelCount > 0 && form.prdTmpId == 3">已售{{form.travelCount}}份</span>
                <span class="count" v-if="form.travelCount > 0 && form.prdTmpId != 3">{{form.travelCount}}人出游</span>
            </div>
        </a>
    </li>
</template>

<script>
    import {eventTrack} from '@/business/analy';
    import {goProductUrl} from '@/business/global';

    export default {
        data () {
            return {
            }
        },
        props: ['form'],
        methods: {
            eventTrack,
            goProductUrl
        }
    }

</script>

<style lang="scss">
@import '../../style/common.scss';
    .recommend-card {
        a {
            display: block;
            width: 100%;
            position: relative;
            border-radius:9px;
            background: #fff;
            overflow: hidden;
            box-shadow: 0 3px 8px rgba(0,0,0,0.08);
        }

        .img-ctn {
            position: relative;
            width: 100%;
            height: 102px;
            background-size: cover;
        }

        .info {
            position: absolute;
            top: 0;
            left: 0;
            height: 19px;
            line-height: 19px;
            padding-right: 8px;
            background: rgba(0,0,0,0.75);
            color: #fff;
            font-size: 12px;
            border-bottom-right-radius: 9px;
            .category {
                display: inline-block;
                background:#32c45d;
                padding: 0 5px;
                border-bottom-right-radius: 9px;
            }
            .satisfaction {
                font-weight: 300;
                opacity: 0.75;
                margin-left: 4px;
            }
        }

        .name {
            margin: 7px 5px;
            height: 36px;
            overflow: hidden;
            font-size:14px;
            font-weight: 700;
            line-height:18px;
            color:#383838;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .price-ctn {
            @include clearfix;
            line-height: 24px;
            padding: 6px 13px;
            .price {
                float: left;
                font-size:12px;
                color:rgba(32,48,64,0.75);
                font-weight: 300;
                i {
                    font-weight: 500;
                    font-style: normal;
                    color:#f9743a;
                }
                em {
                    font-weight: 500;
                    font-family: "DINCondensed-Bold";
                    font-size: 20px;
                    color:#ff6436;
                    margin: 0 2px 0 1px;
                    letter-spacing: 1px;
                }
            }
            .count {
                font-weight: 300;
                font-size: 12px;
                color:#383838;
                float: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Card.vue